module.exports = __webpack_public_path__ + "img/signbutton.48861cca.png";